// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3wk_T","left":"InfoRow_left__1XG3k"};